import { encodeQueryData } from 'Utils/Common';
import http from './httpService';
const API_URL_TARGET = process.env.REACT_APP_API_URL_TARGET;

async function getSingleLoanData(id:any) {
    const url = `${API_URL_TARGET}get_tender/${id}`;
    let response = await http.get(url);
    return response;
}

async function getAllBank(params:any) {
    const url = `${API_URL_TARGET}get_all_banks?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

async function getAllBankFromCity(params:any) {
    const url = `${API_URL_TARGET}get_all_bank_cities?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

async function getAllOffers(params:any) {
    const url = `${API_URL_TARGET}get_all_offers?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

async function postSingleLoanData(obj:any) {
    const url = `${API_URL_TARGET}save_tender_request`;
    let response = await http.post(url, obj);
    return response;
}

async function postSingleLoanDataDeadline(obj:any) {
    const url = `${API_URL_TARGET}save_tender_deadline_request`;
    let response = await http.post(url, obj);
    return response;
}

async function getTenderRequestData(id:any) {
    const url = `${API_URL_TARGET}get_tender_request/${id}`;
    let response = await http.get(url);
    return response;
}

async function updateLoanOffer(data:any,id:any) {
    const url = `${API_URL_TARGET}update_offer/${id}`;
    let response = await http.put(url,data);
    return response;
}

async function updateEndTender(data:any,id:any) {
    const url = `${API_URL_TARGET}end_tender_winner/${id}`;
    let response = await http.put(url,data);
    return response;
}

async function updateHmService(data:any,id:any) {
    const url = `${API_URL_TARGET}send_service_req/${id}`;
    let response = await http.put(url,data);
    return response;
}

async function deleteAttachment(data:any,id:any) {
    const url = `${API_URL_TARGET}deletepdf/${id}`;
    let response = await http.put(url,data);
    return response;
}

async function getAllRefRate() {
    const url = `${API_URL_TARGET}get_ref_rate`;
    let response = await http.get(url);
    return response;
}

async function updateRefRate(data:any) {
    const url = `${API_URL_TARGET}save_ref_rate`;
    let response = await http.post(url,data);
    return response;
}

async function updateRecommendedText(data:any,id:any) {
    const url = `${API_URL_TARGET}update_tender/${id}`;
    let response = await http.put(url,data);
    return response;
}

async function updateOffer(data:any,id:any) {
    const url = `${API_URL_TARGET}update_offer/${id}`;
    let response = await http.put(url,data);
    return response;
}

async function updateBankName(data:any, id:any) {
    const url = `${API_URL_TARGET}update_bank/${id}`;
    let response = await http.put(url,data);
    return response;
}

async function getSettingsData() {
    const url = `${API_URL_TARGET}get_settings`;
    let response = await http.get(url);
    return response;

} 
async function updateSanction(data:any,id:any) {
    const url = `${API_URL_TARGET}update_tender/${id}`;
    let response = await http.put(url,data);
    return response;
}

async function downloadFile(id:any) {
    const url = `${API_URL_TARGET}downloadpdf?loan_status_id=${id}`;
    let response = await http.get(url);
    return response;
}
async function downloadSettingsFile(id:any) {
    const url = `${API_URL_TARGET}download_settings?id=${id}`;
    let response = await http.get(url);
    return response;
}

const SingleLoanServices = {
    getSingleLoanData,
    postSingleLoanData,
    postSingleLoanDataDeadline,
    getAllBank,
    getTenderRequestData,
    getAllOffers,
    updateLoanOffer,
    updateEndTender,
    getAllBankFromCity,
    updateHmService,
    deleteAttachment,
    getAllRefRate,
    updateRefRate,
    updateRecommendedText,
    updateOffer,
    updateBankName,
    getSettingsData,
    updateSanction,
    downloadFile,
    downloadSettingsFile
};

export default SingleLoanServices;